export default __webpack_public_path__ + "static/media/icon_menu_black.28291d72.svg";